export const appConfig = {
  APP_URL:
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:3301'
      : 'https://admin.experthire.fr',
  BASE_API_URL:
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:8080'
      : 'https://api.experthire.fr',
  BASE_URL:
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:8080/api/v1'
      : 'https://api.experthire.fr/api/v1',
  USER_PROFILE_IMAGE_KEY: 'iqc_admin_profile_image_url',
  USER_SESSION_TOKEN_KEY: 'iqc_admin_token',
  authConfig: {
    currentLocationKey: 'redirectUri',
    idTokenHintKey: 'id_token',
    webAuthResponseType: 'code',
  },
};
